<template>
  <MyModal
    :leftArrow="islx"
    @leftClick="handleLeftClick"
    title="资源概况"
    height="auto"
    v-if="isShowFace"
    :className="classNames"
    @closeClick="handleCloseModalClick"
  >
    <div v-if="!islx" class="my-face-content">
      <div class="top-area">
        <div class="item">
          <div class="label">名称:</div>
          <div class="desc">{{ itemConfig.itemName || '未命名' }} （面积：{{ itemConfig.area || '-' }} km²）</div>
        </div>
        <div class="item">
          <div class="label">数据源:</div>
          <div class="desc">
            <el-select
              v-model="datasetCode"
              placeholder="选择数据源"
              @change="handleSelectChange"
            >
              <el-option
                v-for="(v, i) in dataSet"
                :key="i"
                :label="v.datasetName"
                :value="v.datasetCode"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="item">
          <div class="label">高度:</div>
          <div class="desc">
            <el-select
              v-model="datasetHeight"
              placeholder="选择高度"
              @change="handleDataHeightChange"
            >
              <el-option
                v-for="(v, i) in heightList"
                :key="i"
                :label="v + 'm'"
                :value="v"
              ></el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div class="btn-area">
        <div
          v-for="(item, index) in btnList"
          :key="index"
          :class="[
            'btn-item',
            {
              'is-active': item.elementCode === elementCode
            }
          ]"
          @click="handleBtnClick(item, index)"
        >
          {{ item.name }}
        </div>
      </div>
      <div class="data-area">
        <el-radio
          :value="legendRange"
          label="2"
          @change="handleRightLegendChange"
          >动态数据范围</el-radio
        >
        <el-radio
          :value="legendRange"
          label="1"
          @change="handleLeftLegendChange"
          >固定数据范围</el-radio
        >
      </div>
      <div
        class="pic-area"
        id="my-node"
        v-if="activeValues.length > 0 && !loading"
      >
        <color-simple
          type="horizontal"
          :colors="colors"
          :values="activeValues"
          :unit="activeUnit"
          width="100%"
        ></color-simple>
        <!-- <img class="img-current" :src="config.tupuUrl" /> -->
      </div>
      <div class="link-area" v-if="config.itemId != 0">
        <!-- <el-button type="text" @click="closeTupu">关闭图谱</el-button> -->

        <template v-if="isLogin">
          <el-button type="text" @click="imgDownLoad">图片下载</el-button>
          <el-button v-if="!fromProjectList||true" type="text" @click="tupuDownLoad"
            >图谱下载</el-button
          >
          <el-button v-if="!fromProjectList&&false" type="text" @click="handleLXClick"
            >资源遴选</el-button
          >
        </template>
      </div>
      <div class="link-area" v-else>
          <el-button type="text" @click="save">保存</el-button>
      </div>
    </div>

    <div v-else class="my-face-content">
      <div class="form-area">
        <div class="form-item">
          <div class="key">年平均风速</div>
          <div class="value">
            <StandInput
              v-model="windSelectionInfo.avgSpeedYear"
              :onlyNumber="true"
              unit="m/s"
            ></StandInput>
          </div>
        </div>
        <!-- <div class="form-item">
          <div class="key">满发小时数</div>
          <div class="value">
            <StandInput
              v-model="windSelectionInfo.fullHour"
              :onlyNumber="true"
              unit="h"
            ></StandInput>
          </div>
        </div> -->
        <div class="form-item">
          <div class="key">最高海拔</div>
          <div class="value">
            <StandInput
              v-model="windSelectionInfo.altitudeTo"
              :onlyNumber="true"
              :precision="1"
              unit="m"
            ></StandInput>
          </div>
        </div>
        <div class="form-item">
          <div class="key">最大坡度</div>
          <div class="value">
            <StandInput
              v-model="windSelectionInfo.slopeTo"
              :onlyNumber="true"
              unit="度"
            ></StandInput>
          </div>
        </div>
        <div class="form-item">
          <div class="key">土地利用系数</div>
          <div class="value">
            <StandInput
              v-model="windSelectionInfo.landUseRatio"
              :onlyNumber="true"
            ></StandInput>
          </div>
        </div>
      </div>

      <div class="lx-limit-area">
        <div class="my-title">
          限制区域
          <i
            :class="[
              'el-icon-circle-plus-outline',
              {
                'is-active': toolUIStatus.lxLimitAdd
              }
            ]"
            @click="
              () => {
                handleLimitClick();
              }
            "
          ></i>
        </div>
        <div class="area-content">
          <div
            class="depoly-content-item"
            v-for="(item, index) in exclusiveList"
            :key="index"
          >
            <el-tag> 限制区域{{ Number(index) + 1 }}</el-tag>
            <div class="btns">
              <i
                :class="[
                  'el-icon-view',
                  {
                    'is-active': item.isShow
                  }
                ]"
                @click="handleViewClick(item, index)"
              ></i>
              <i
                class="el-icon-delete"
                @click="handleDelLimitClick(item, index)"
              ></i>
            </div>
          </div>
        </div>
      </div>
      <div class="btn-wrapper">
        <ct-button type="primary" :btnClick="handleLxDClick"
          >开始遴选</ct-button
        >
      </div>
    </div>
  </MyModal>
</template>

<script>
import flattenDepth from 'lodash/flattenDepth';
import { FLOW_COLORS } from '@/utils/constants';
import domtoimage from 'dom-to-image';
import {
  parseMapDataToGeoInfo,
  toFixed,
  parseGeoInfoToMapData
} from '../../utils';
import StandInput from '../../stand-input';
import MyModal from '../../modal';
import { mapGetters } from 'vuex';
import { getToken } from '../../../../utils';
import cloneDeep from 'lodash/cloneDeep';
export default {
  components: {
    MyModal,
    StandInput
  },
  props: {
    itemConfig: {
      type: Object,
      default: () => ({})
    },
    fromProjectList: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      colors: FLOW_COLORS,
      a: '',
      islx: false,
      config: {
        itemName: '',
        elementCode: ''
      },
      heightList: [],
      loading: false,

      windSelectionInfo: {
        avgSpeedYear: null,
        // fullHour: null,
        altitudeTo: null,
        slopeTo: null,
        landUseRatio: null,
        distanceFrom: 90,
        distanceTo: 10000
      },
      btnList: [
        {
          name: '风速',
          elementCode: 'wspd',
          dyValues: [],
          values: [3, 4, 5, 6, 7, 8, 9, 10],
          unit: 'm/s'
        },
        {
          name: '风功率',
          elementCode: 'wpd',
          unit: 'W/㎡',
          dyValues: [],
          values: [0, 150, 300, 450, 600, 750, 900, 1050]
        },
        {
          name: '空气密度',
          elementCode: 'rhoair',
          unit: 'kg/m³',
          dyValues: [],
          values: [0.7,0.8,0.9,1.0,1.1,1.2,1.3]
        },
        {
          name: '气温',
          elementCode: 't',
          dyValues: [],
          values: [-10, -5, 0, 5, 10, 15, 20, 25, 30],
          unit: '℃'
        },
        {
          name: '气压',
          elementCode: 'p',
          dyValues: [],
          unit: 'hPa',
          values: [700,750,800,850,900,950,1000]
        }/*,
        {
          name: '误差',
          elementCode: 'bias',
          dyValues: [],
          unit: 'm/s',
          values: [0,0.25,0.5,0.75,1,1.25,1.5,1.75,2]
        }*/
      ],
      exclusiveList: [],
      datasetCode: '',
      datasetHeight: '',
      elementCode: '',
      legendRange: '',
      itemId: '',
      activeValues: [],
      activeUnit: '',
      picName: '',
      isShowFace: true
    };
  },
  computed: {
    ...mapGetters(['isLogin']),
    ...mapGetters('WindFarm', ['toolUIStatus', 'dataSet']),
    classNames() {
      if (!this.isLogin) {
        return 'not-login';
      } else {
        return '';
      }
    },
    itemConfigCopy(){
      return this.itemConfig;
    }
  },
  watch: {
    // config: {
    //   handler(val) {
    //     this.$emit('update:itemConfig', val);
    //   },
    //   immediate: true,
    //   deep: true
    // },

    datasetCode: {
      handler(val) {
        this.config.datasetCode = val;
        this.$emit('update:itemConfig', this.config);
        if(this.config.itemId == 0){
          this.$emit('setNoIdFaceItem', {
            datasetCode: val,
            datasetHeight: this.config.datasetHeight
          });
        }
      },
      immediate: true
    },

    datasetHeight: {
      handler(val) {
        this.config.datasetHeight = val;
        this.$emit('update:itemConfig', this.config);
        if(this.config.itemId == 0){
          this.$emit('setNoIdFaceItem', {
            datasetCode: this.config.datasetCode,
            datasetHeight: val
          });
        }
      },
      immediate: true
    },

    elementCode: {
      handler(val) {
        this.config.elementCode = val;
        this.$emit('update:itemConfig', this.config);
      },
      immediate: true
    },

    legendRange: {
      handler(val) {
        this.config.legendRange = val;
        this.$emit('update:itemConfig', this.config);
      },
      immediate: true
    },

    itemConfigCopy: {
      handler(val, prev) {
        if (!val) return;
        if(val.itemId && (val.itemId == this.config.itemId)){
          return;
        }else{
          if(val.adcode && (val.adcode == this.config.adcode)){
            return;
          }
        }

        this.isShowFace = true;

        if (prev) {
          this.islx = false;
        }

        this.config = val;

        const {
          datasetCode = '',
          datasetHeight = '',
          elementCode = '',
          legendRange = '',
          itemId = ''
        } = val;

        if (datasetCode) {
          const item = this.dataSet.find(
            item => item.datasetCode === datasetCode
          );
          this.heightList = item?.datasetHeight || [];
          this.datasetCode = datasetCode;
          if(!datasetHeight){
            this.datasetHeight = this.heightList[0];
          }else{
            if(this.heightList.indexOf(datasetHeight) > -1){
              this.datasetHeight = datasetHeight
            }else{
              this.datasetHeight = this.heightList[0];
            }
          }

        } else {
          const firstItem = this.dataSet[0];
          this.datasetCode = firstItem?.datasetCode;
          this.heightList = firstItem.datasetHeight;
          this.datasetHeight = this.heightList[0];
        }

        if(itemId == 0){
          this.$emit('setNoIdFaceItem', {
            datasetCode: this.datasetCode,
            datasetHeight: this.datasetHeight
          });
        }
        // console.log("====",this.datasetHeight);

        this.elementCode = elementCode || 'wspd';
        this.legendRange = legendRange || '2';

        this.$store.commit('WindFarm/SET_RAW_POLYGONS', {
          type: 'lx-limit-area',
          data: []
        });

        if (this.datasetCode && this.datasetHeight) {
          this.queryUrl({
            datasetCode: this.datasetCode,
            datasetHeight: this.datasetHeight,
            itemId: itemId,
            elementCode: this.elementCode,
            legendRange: this.legendRange
          });
        }

        // if(val.itemId == 0){
        //   this.requestImg();
        // }
      },
      immediate: true
    },
    islx: {
      handler(val) {
        if (val) {
          this.querySelectionArea();
        } else {
          this.$store.commit('WindFarm/SET_RAW_POLYGONS', {
            type: 'lx-limit-area',
            data: []
          });

          this.$store.commit('WindFarm/SET_RAW_POLYGONS', {
            type: 'lx-result-area',
            data: []
          });
        }
      }
    }
  },
  created() {
    this.$bus.$on('createLXLimitAdd', this.createLxLimitAdd);
  },
  beforeDestroy() {
    this.$bus.$off('createLXLimitAdd', this.createLxLimitAdd);

    this.$store.commit('WindFarm/SET_RAW_POLYGONS', {
      type: 'lx-limit-area',
      data: []
    });

    this.$store.commit('WindFarm/SET_RAW_POLYGONS', {
      type: 'lx-result-area',
      data: []
    });
  },
  mounted() {},
  methods: {
    save(){
      // this.isShowFace = false;
      this.config = {
        itemId : 'default',
        itemName: '',
        elementCode: ''
      };
      this.$bus.$emit('saveCreateItemRect',{
        datasetCode: this.datasetCode,
        datasetHeight: this.datasetHeight
      });
    },
    handleCloseModalClick() {
      if(this.config.itemId == 0){
        if (this.config.itemType == 2) {
          this.$store.commit('WindFarm/POP_MAPDATA_RECT');
        }
        if (this.config.itemType == 3) {
          this.$store.commit('WindFarm/POP_MAPDATA_POLYGONS');
        }
      }
      this.isShowFace = false;
      this.config = {
        itemId : 'default',
        itemName: '',
        elementCode: ''
      };

    },
    getActiveUnit() {
      if (!this.elementCode) {
        return '';
      }
      return this.btnList.find(i => i.elementCode === this.elementCode)?.unit;
    },
    getActiveValues() {
      if (!this.elementCode) {
        return [];
      }

      if (this.legendRange == 2) {
        return this.btnList.find(i => i.elementCode === this.elementCode)
          .dyValues;
      }
      if (this.legendRange == 1) {
        return this.btnList.find(i => i.elementCode === this.elementCode)
          .values;
      }
      return [];
    },
    updateElemenCodeValue(max, min) {
      if (this.legendRange == 2) {
        const item = this.btnList.find(i => i.elementCode === this.elementCode);
        const num = Math.round(item.values.length * 1);
        const unit = (max - min) / (num - 1);
        const newArr = new Array(num).fill('');


        item.dyValues = newArr.map((i, index) => {
          let fixUnit = 0;
          if (this.elementCode === 'wspd' || this.elementCode === 't') {
            fixUnit = 1;
          }else if (this.elementCode === 'rhoair' || this.elementCode === 'bias') {
            fixUnit = 2;
          }

          return toFixed(min + unit * index, fixUnit);
        });

/*      if (this.elementCode === 'p') {
          const item = this.btnList.find(
            i => i.elementCode === this.elementCode
          );
          item.values = newArr.map((i, index) => {
            let fixUnit = 0;
            return toFixed(min + unit * index, fixUnit);
          });
        } */
      }
    },
    handleLxDClick() {
      let arr = [];

      this.exclusiveList.forEach(i => {
        arr.push(i.data);
      });

      const newArr = arr.map(i => {
        return i.map(item => [item.lng, item.lat]);
      });

      const strs = newArr
        .map(item => {
          return JSON.stringify({
            type: 'Polygon',
            coordinates: [item]
          });
        })
        .join(';');

      this.$fetch({
        method: 'POST',
        url: '/windfarm/station/windSelection',
        data: {
          ...this.windSelectionInfo,
          geometryInfos: strs,
          itemId: this.itemConfig.itemId,
          dataSet: this.itemConfig.datasetCode,
          dataHeight: this.itemConfig.datasetHeight
        },
        showError: true,
        showLoading: true,
        showSuccess: true
      }).then(() => {
        this.querySelectionArea();
      });
    },
    handleLimitClick(value) {
      let status;

      if (value !== undefined) {
        status = !value;
      } else {
        status = this.toolUIStatus['lxLimitAdd'];
      }

      this.$store.commit('WindFarm/RESET_UI_AND_BAR_STATUS');
      this.$store.commit('WindFarm/SET_TOOL_UI_STATUS', {
        key: 'lxLimitAdd',
        value: !status
      });

      this.$store.commit('WindFarm/SET_TOOL_BAR_STATUS', {
        key: 'drawPolygon',
        value: !status
      });
    },
    handleViewClick(item) {
      item.isShow = !item.isShow;
      const arr = this.exclusiveList.filter(i => !!i.isShow).map(i => i.data);

      this.$store.commit('WindFarm/SET_RAW_POLYGONS', {
        type: 'lx-limit-area',
        data: arr
      });
    },

    handleDelLimitClick(item, index) {
      this.exclusiveList.splice(index, 1);
      const arr = this.exclusiveList.filter(i => !!i.isShow).map(i => i.data);

      this.$store.commit('WindFarm/SET_RAW_POLYGONS', {
        type: 'lx-limit-area',
        data: arr
      });
    },
    createLxLimitAdd(data) {
      this.handleLimitClick(false);

      const str = parseMapDataToGeoInfo(data, 'Polygon');
      this.exclusiveList.push({
        data: data,
        geo: str,
        isShow: true
      });

      const arr = this.exclusiveList.filter(i => !!i.isShow).map(i => i.data);

      this.$store.commit('WindFarm/SET_RAW_POLYGONS', {
        type: 'lx-limit-area',
        data: arr
      });
    },
    querySelectionArea() {
      this.$fetch('/windfarm/station/getWindSelection', {
        showError: true,
        params: {
          itemId: this.config.itemId
        }
      }).then(res => {
        const { exclusiveList = [], itemSelectionList = {} } = res.data;

        this.exclusiveList = exclusiveList.map(i => {
          const { geometryInfo = '' } = i;

          return {
            ...i,
            data: geometryInfo ? parseGeoInfoToMapData(geometryInfo)[0] : [],
            isShow: true
          };
        });

        this.windSelectionInfo = {
          avgSpeedYear: itemSelectionList.wspd,
          // fullHour: itemSelectionList.fullLoadHours,
          altitudeTo: itemSelectionList.maxAltitude,
          slopeTo: itemSelectionList.maxSlope,
          landUseRatio: itemSelectionList.landUseRatio,
          distanceFrom: 90,
          distanceTo: 10000
        };

        const { geometryInfo: lxGeoInfo } = itemSelectionList;

        const lxMapData = lxGeoInfo ? JSON.parse(lxGeoInfo)['coordinates'] : [];

        getMap(lxMapData, 'lx-result-area');

        this.$store.commit('WindFarm/SET_RAW_POLYGONS_ARR', {
          type: 'lx-result-area',
          data: lxMapData
        });

        const arr = this.exclusiveList.filter(i => !!i.isShow).map(i => i.data);

        this.$store.commit('WindFarm/SET_RAW_POLYGONS', {
          type: 'lx-limit-area',
          data: arr
        });

        function getMap(array, type) {
          if (!array.length) return array;

          if (Array.isArray(array) && typeof array[0] === 'number') {
            array[0] = {
              type,
              lat: array[1],
              lng: array[0]
            };

            array.length = 1;
            return 'change';
            // Reflect.deleteProperty(array, '1');
          } else {
            for (let i = 0; i < array.length; i++) {
              let flag = getMap(array[i], type);

              if (flag === 'change') {
                array[i] = array[i][0];
              }
            }
          }
        }
      });
    },
    handleLeftLegendChange() {
      this.legendRange = '1';
      this.queryUrl({
        datasetCode: this.datasetCode,
        datasetHeight: this.datasetHeight,
        itemId: this.config.itemId,
        elementCode: this.elementCode,
        legendRange: this.legendRange
      });
    },
    handleRightLegendChange() {
      this.legendRange = '2';
      this.queryUrl({
        datasetCode: this.datasetCode,
        datasetHeight: this.datasetHeight,
        itemId: this.config.itemId,
        elementCode: this.elementCode,
        legendRange: this.legendRange
      });
    },
    handleBtnClick(item) {
      if (this.elementCode === item.elementCode) {
        return this.closeTupu();
      }

      this.elementCode = item.elementCode;

      this.queryUrl({
        datasetCode: this.datasetCode,
        datasetHeight: this.datasetHeight,
        itemId: this.config.itemId,
        elementCode: this.elementCode,
        legendRange: this.legendRange
      });
    },
    handleLXClick() {
      this.islx = true;
    },
    handleLeftClick() {
      this.islx = false;
    },
    handleSelectChange(val) {
      const item = this.dataSet.find(item => item.datasetCode === val);
      this.heightList = item?.datasetHeight;
      this.datasetHeight = this.heightList[0] || '';

      this.queryUrl({
        datasetCode: this.datasetCode,
        datasetHeight: this.datasetHeight,
        itemId: this.config.itemId,
        elementCode: this.elementCode,
        legendRange: this.legendRange
      });
    },
    handleDataHeightChange() {
      this.queryUrl({
        datasetCode: this.datasetCode,
        datasetHeight: this.datasetHeight,
        itemId: this.config.itemId,
        elementCode: this.elementCode,
        legendRange: this.legendRange
      });
    },
    queryUrl(params) {
      if (!params.elementCode) return;

      const {
        datasetCode = '',
        datasetHeight = '',
        itemId = '',
        elementCode = '',
        legendRange = ''
      } = params;

      this.loading = true;
      if (this.itemConfig.itemId == 0) {
        this.$postForm('/windfarm/project/plane/getElementsPicPath', {
          data: {
            datasetCode,
            datasetHeight,
            itemId: '0',
            elementCode,
            legendRange,
            geometryInfo: this.itemConfig.adcode
              ? null
              : this.itemConfig.geometryInfo || null,
            adcode: this.itemConfig.adcode || null
          },
          noKey: false,
          showError: true
        }).then(res => {
          this.loading = false;
          const { data } = res;
          const { atlas, max, min } = data;
          const tupuUrl = process.env.VUE_APP_API_HOST + '/windfarm' + atlas;
          // todo更新URL
          const arr = atlas.split('?');
          this.picName = arr[1].split('=')[1];

          this.updateElemenCodeValue(max, min);

          this.activeValues = this.getActiveValues();
          this.activeUnit = this.getActiveUnit();

          this.$emit('updateImg', {
            id: itemId,
            url: tupuUrl + '&version=' + new Date().valueOf()
          });
        });
      } else {
        this.$emit('updateItem',{
          datasetCode,
          datasetHeight,
          itemId
        });
        this.$fetch('/windfarm/project/plane/getElementsPicPath', {
          params: {
            datasetCode,
            datasetHeight,
            itemId,
            elementCode,
            legendRange
          },
          showError: true
        }).then(res => {
          this.loading = false;

          const { data } = res;
          const { atlas, max, min } = data;
          const tupuUrl = process.env.VUE_APP_API_HOST + '/windfarm' + atlas;

          const arr = atlas.split('?');
          this.picName = arr[1].split('=')[1];

          // todo更新URL

          this.updateElemenCodeValue(max, min);

          this.activeValues = this.getActiveValues();
          this.activeUnit = this.getActiveUnit();

          this.$emit('updateImg', {
            id: itemId,
            url: tupuUrl + '&version=' + new Date().valueOf()
          });

        });
      }
    },
    imgDownLoad() {
      if (!this.picName) {
        return this.$message.warning('图片还没准备好，请稍后再试');
      }

      fetch(
        `${
          process.env.VUE_APP_API_HOST
        }/windfarm/project/plane/getElementsPic?url=${
          this.picName
        }&apiKey=${getToken()}&version=${new Date().valueOf()}`
      )
        .then(res => {
          return res.blob();
        })
        .then(data => {
          const blob = new Blob([data]);

          var link = document.createElement('a');
          var fileURL = URL.createObjectURL(blob);

          link.target = '_blank';
          link.href = fileURL;
          link.download = `${this.itemConfig.itemName}_${this.datasetHeight}_${this.elementCode}.png`;
          link.click();
        });

      // this.$fetch(`/windfarm/project/plane/getElementsPic`, {
      //   params: {
      //     url: this.picName,
      //     version: new Date().valueOf()
      //   },
      //   showLoading: true,
      //   noJudge: true
      // }).then(res => {
      //   const blob = new Blob([res.data]);

      //   var link = document.createElement('a');
      //   var fileURL = URL.createObjectURL(blob);

      //   link.target = '_blank';
      //   link.href = fileURL;
      //   link.download = this.picName;
      //   link.click();
      // });

      // window.open(
      //   `${process.env.VUE_APP_API_HOST}/windfarm/project/plane/getElementsPic?url=${this.picName}`,
      //   '__parent'
      // );
      // const link = document.createElement('a');
      // link.href = `${process.env.VUE_APP_API_HOST}/windfarm/project/plane/getElementsPic?url=${this.picName}`;
      // link.download = this.picName;
      // link.target = '_blank';
      // link.style.display = 'none';
      // document.body.appendChild(link);
      // link.click();
      // document.body.removeChild(link);
    },
    closeTupu() {
      this.$emit('updateImg', {
        id: this.itemConfig.itemId,
        url: ''
      });

      this.elementCode = '';
      this.activeValues = this.getActiveValues();
    },
    tupuDownLoad() {
      const node = document.getElementById('my-node');
      domtoimage.toJpeg(node).then(async dataurl => {
        const file = new File([dataURItoBlob(dataurl)], '图例.jpg', {
          type: 'jpg'
        });
        const formData = new FormData();
        const geometryInfos = this.itemConfig.geometryInfo;

        let data = parseGeoInfoToMapData(geometryInfos)[0];

        if (this.itemConfig.itemType === 4) {
          const result = await this.$fetch(
            '/windfarm/project/getRegionBoundary',
            {
              showError: true,
              params: {
                // 拿默认的
                regionId: this.itemConfig.adcode
              }
            }
          ).then(res => {
            const { data = {} } = res || [];
            const { regionBoundary = { coordinates: '' } } = data;

            let result = JSON.parse(regionBoundary).coordinates || [];
            return result[0][0].map(i => ({ lat: i[1], lng: i[0] }));
          });

          data = result;
        }

        const { maxLat, maxLon, minLat, minLon } = this.getMax(data);

        formData.append('apiKey', getToken());
        formData.append('datasetCode', this.datasetCode);
        formData.append('datasetHeight', this.datasetHeight);
        formData.append('elementCode', this.elementCode);
        formData.append('file', file);
        formData.append('itemId', this.itemConfig.itemId);
        formData.append('legendRange', this.legendRange);
        formData.append('picName', this.picName);
        formData.append('maxLat', maxLat);
        formData.append('maxLon', maxLon);
        formData.append('minLat', minLat);
        formData.append('minLon', minLon);

        this.$fetch({
          method: 'post',
          url: '/windfarm/project/plane/getKmzFile',
          data: formData,
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          noJudge: true,
          showLoading: true
        }).then(() => {
          const download = `${this.itemConfig.itemId}_${this.datasetHeight}_${this.elementCode}_${this.legendRange}.kmz`;

          fetch(
            `${process.env.VUE_APP_API_HOST}/windfarm/project/plane/downKmz?kmzName=${download}`
          ).then(res => {
            return res.blob();
          }).then(data => {
            const blob = new Blob([data]);
            var link = document.createElement('a');
            var fileURL = URL.createObjectURL(blob);
            link.target = '_blank';
            link.href = fileURL;
            link.download = `${this.itemConfig.itemName}_${this.datasetHeight}_${this.elementCode}.kmz`;
            link.click();
          });

          /*
          var link = document.createElement('a');
          //var fileURL = URL.createObjectURL(blob);

          link.target = '_blank';
          link.href = `${process.env.VUE_APP_API_HOST}/windfarm/project/plane/downKmz?kmzName=${download}`;
          link.download = download;
          link.click();
*/
/*           window.open(
            `${process.env.VUE_APP_API_HOST}/windfarm/project/plane/downKmz?kmzName=${download}`,
            '_parent'
          ); */
        });
      });

      function dataURItoBlob(dataURI) {
        // convert base64 to raw binary data held in a string
        // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
        var byteString = atob(dataURI.split(',')[1]);

        // separate out the mime component
        var mimeString = dataURI
          .split(',')[0]
          .split(':')[1]
          .split(';')[0];

        // write the bytes of the string to an ArrayBuffer
        var ab = new ArrayBuffer(byteString.length);
        var ia = new Uint8Array(ab);
        for (var i = 0; i < byteString.length; i++) {
          ia[i] = byteString.charCodeAt(i);
        }

        //Old Code
        //write the ArrayBuffer to a blob, and you're done
        //var bb = new BlobBuilder();
        //bb.append(ab);
        //return bb.getBlob(mimeString);

        //New Code
        return new Blob([ab], { type: mimeString });
      }
    },

    getMax(data) {
      let maxLat = -1000;
      let maxLon = -1000;
      let minLat = 1000;
      let minLon = 1000;

      const newData = flattenDepth(data, 4);

      newData.forEach(item => {
        const { lat, lng } = item;

        if (maxLat < lat) {
          maxLat = lat;
        }

        if (minLat > lat) {
          minLat = lat;
        }

        if (maxLon < lng) {
          maxLon = lng;
        }

        if (minLon > lng) {
          minLon = lng;
        }
      });

      return {
        maxLat,
        minLat,
        maxLon,
        minLon
      };
    },

    requestImg() {
      let areas = [{...this.config}];
      let imgMapData = areas
              .filter(i => i.visible)
              .filter(i => i.tupuUrl)
              .map(i => {
                if (i.itemType != 4) {
                  const data = parseGeoInfoToMapData(i.geometryInfo)[0];

                  let maxLat = -1000;
                  let maxLng = -1000;
                  let minLat = 1000;
                  let minLng = 1000;

                  data.forEach(item => {
                    const { lat, lng } = item;

                    if (maxLat < lat) {
                      maxLat = lat;
                    }

                    if (minLat > lat) {
                      minLat = lat;
                    }

                    if (maxLng < lng) {
                      maxLng = lng;
                    }

                    if (minLng > lng) {
                      minLng = lng;
                    }
                  });

                  const _data = [
                    {
                      lat: maxLat,
                      lng: minLng
                    },
                    {
                      lat: maxLat,
                      lng: maxLng
                    },
                    {
                      lat: minLat,
                      lng: maxLng
                    },
                    {
                      lat: minLat,
                      lng: minLng
                    }
                  ];

                  return {
                    url: i.tupuUrl,
                    latlngs: _data
                  };
                } else {
                  const geoData = cloneDeep(i.mapGeo);
                  this.getMap(geoData);
                  const newData = flattenDepth(geoData, 4);

                  let maxLat = -1000;
                  let maxLng = -1000;
                  let minLat = 1000;
                  let minLng = 1000;

                  newData.forEach(item => {
                    const { lat, lng } = item;

                    if (maxLat < lat) {
                      maxLat = lat;
                    }

                    if (minLat > lat) {
                      minLat = lat;
                    }

                    if (maxLng < lng) {
                      maxLng = lng;
                    }

                    if (minLng > lng) {
                      minLng = lng;
                    }
                  });

                  const _data = [
                    {
                      lat: maxLat,
                      lng: minLng
                    },
                    {
                      lat: maxLat,
                      lng: maxLng
                    },
                    {
                      lat: minLat,
                      lng: maxLng
                    },
                    {
                      lat: minLat,
                      lng: minLng
                    }
                  ];

                  return {
                    url: i.tupuUrl,
                    latlngs: _data
                  };
                }
              });

      // if (this.plusImgArr[0]?.url) {
      //   imgMapData = [...imgMapData, ...this.plusImgArr];
      // }

      this.$store.commit('WindFarm/SET_IMAGE', imgMapData);
    },
    getMap(array, id = null) {
      if (!array.length) return array;

      if (Array.isArray(array) && typeof array[0] === 'number') {
        if (id === null || id === undefined) {
          array[0] = {
            lat: array[1],
            lng: array[0]
          };
        } else {
          array[0] = {
            id,
            lat: array[1],
            lng: array[0]
          };
        }

        array.length = 1;
        return 'change';
        // Reflect.deleteProperty(array, '1');
      } else {
        for (let i = 0; i < array.length; i++) {
          let flag = this.getMap(array[i], id);

          if (flag === 'change') {
            array[i] = array[i][0];
          }
        }
      }
    },
  }
};
</script>

<style lang="less" scoped>
.my-face-content {
  padding: 0 20px 10px 20px;

  .form-area {
    background-color: #fff;
    border-radius: 7px;
    padding: 20px 20px 10px 20px;

    .form-item {
      margin-bottom: 10px;
      display: flex;
      align-items: center;
      &.sp {
        margin-top: 15px;
      }
    }

    .key {
      margin-right: 5px;
      width: 150px;
      line-height: 30px;
      font-weight: 500;
    }
    .value {
      width: 120px;
    }
  }
}
.top-area {
  .item {
    height: 36px;
    display: flex;
    align-items: center;
    padding: 3px 0px;
    .label {
      color: #000;
      width: 48px;
      text-align: right;
      margin-right: 10px;
    }
    .desc {
      color: #555;
    }
  }
}
.btn-area {
  margin-top: 10px;
  display: flex;
  font-size: 12px;
  .btn-item {
    display: inline-block;
    padding: 5px 0;
    line-height: 20px;
    flex: 1;
    border: 2px solid #a8cae9;
    text-align: center;
    border-radius: 4px;
    cursor: pointer;
    margin-bottom: 13px;
    background-color: #d9e6f3;

    &:not(:last-child) {
      margin-right: 5px;
    }

    &.is-active {
      background-color: #0159ac;
      color: #fff;
    }
  }
}

.pic-area {
  background-color: #fff;
  border-radius: 6px;
  padding: 10px;
  .img-current {
    width: 100%;
  }
}
.link-area {
  text-align: right;
  margin-top: 10px;
  // display: flex;
}

.data-area {
  text-align: center;
  margin-bottom: 10px;
}
.lx-limit-area {
  margin-top: 10px;

  .area-content {
    margin-top: 10px;
    padding: 0px 10px;
    max-height: 120px;
    overflow: auto;
  }
  .depoly-content-item {
    &:nth-child(n + 1) {
      margin-top: 5px;
    }
    display: flex;
    align-items: center;
    position: relative;
    & > span {
      display: flex;
      align-items: center;
    }

    .btns {
      display: flex;
      align-items: center;
      position: absolute;
      right: 0;
      i {
        display: flex;
        align-items: center;
        cursor: pointer;

        &.is-active {
          color: #3cc2e6;
        }
        &:hover {
          color: #478beb;
        }
        &:first-child {
          margin-right: 10px;
        }
      }
    }
  }

  .my-title {
    font-weight: normal;
    font-size: 16px;
    color: #000;
    padding: 0px 10px;
    position: relative;
    &::before {
      content: '';
      display: block;
      position: absolute;
      left: 0px;
      top: 1px;
      border-radius: 3px;
      width: 5px;
      height: 100%;
      background-color: #015aac;
    }
    i {
      cursor: pointer;
      &:hover {
        color: #478beb;
      }
      &.is-active {
        color: #0159ac;
      }
    }
  }
}
.btn-wrapper {
  margin-top: 10px;
  text-align: right;
}
</style>
